const url = "https://api.mitrarecharge.com/api/";

exports.baseUrl = url;
